<template>
  <div class="modal-auth">
    <template v-if="mode === 'auth'">
      <h2 class="modal-auth__title">
        Вход в личный кабинет
      </h2>

      <login-form @success="$emit('success')" />

      <p class="modal-auth__link">
        Нет аккаунта?
        <a href="#"
          @click.prevent="mode = 'register'">
          ЗАРЕГИСТРИРОВАТЬСЯ
        </a>
      </p>
      <p class="modal-auth__link">
        Забыли пароль?
        <a href="#"
          @click.prevent="mode = 'reset'">
          ВОССТАНОВИТЬ ПАРОЛЬ
        </a>
      </p>
    </template>

    <template v-else-if="mode === 'register'">
      <h2 class="modal-auth__title">
        Регистрация
      </h2>

      <register-form @go-to="goTo" />

      <p class="modal-auth__link">
        Уже зарегистрированы?
        <a href="#"
          @click.prevent="mode = 'auth'">
          ВОЙТИ В КАБИНЕТ
        </a>
      </p>
    </template>

    <template v-else-if="mode === 'reset'">
      <h2 class="modal-auth__title">
        Восстановление пароля
      </h2>

      <reset-form @go-to="goTo" />

      <p class="modal-auth__link">
        Вспомнили пароль?
        <a href="#"
          @click.prevent="mode = 'auth'">
          ВОЙТИ В КАБИНЕТ
        </a>
      </p>
    </template>
  </div>
</template>

<script>
import { ref } from 'vue';

import LoginForm from '@/components/auth/LoginForm.vue';
import RegisterForm from '@/components/auth/RegisterForm.vue';
import ResetForm from '@/components/auth/ResetForm.vue';

export default {
  components: {
    LoginForm,
    RegisterForm,
    ResetForm,
  },
  emits: ['success'],
  setup() {
    const mode = ref('auth');

    const goTo = (payload) => mode.value = payload;

    return { mode, goTo };
  },
};
</script>

<style lang="scss" scoped>
.modal-auth {
  padding: 40px;
  will-change: transform;
  max-width: 765px;

  @include phone {
    padding: 30px 20px;
  }

  .page_scrolled &,
  .ismm & {
    color: $color_dark-80;
    background-color: $white;
    border-top: 1px solid $color_dark-70;
  }

  ._secondary & {
    top: 89px;
  }

  &__title {
    font-size: 36px;
    line-height: 42px;
    margin-bottom: 60px;

    @include phone {
      font-size: 24px;
      line-height: 120%;
      margin-bottom: 40px;
    }
  }

  :deep &__form-link {
    color: $color_orange-50;
  }

  :deep &__subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #A0A2A6;
    margin-bottom: 20px;
  }

  :deep &__form {
    margin-bottom: 20px;
  }

  :deep &__form-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 46px;
    margin-bottom: 30px;

    @include phone {
      gap: 28px;
    }
  }

  :deep &__form-row {
    display: flex;
    gap: 10px;

    @include phone {
      flex-direction: column;
      gap: 28px;
    }

    &>* {
      flex: 1 1 50%;
    }
  }

  :deep &__form-col {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  :deep &__form-actions {
    display: flex;
    align-items: center;

    @include phone {
      flex-direction: column;
      gap: 28px;
    }

    &>* {
      flex: 0 1 50%;
    }

    & button {
      flex: 0 0 auto;
      margin-left: auto;
      padding: 16px 50px !important;

      @include phone {
        padding: 9px 20px !important;
        margin-left: 0;
      }
    }
  }

  &__link {
    display: block;
    width: fit-content;
    font-size: 12px;
    line-height: 24px;

    @include phone {
      margin: 0 auto;
    }

    a {
      color: $color_orange-50;
    }
  }
}

:deep .form-input {
  &__field {
    background-color: transparent;
    padding: 8px 15px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    @include phone {
      font-size: 12px;
      line-height: 120%;
    }
  }

  &__row {
    display: flex;
    gap: 10px;

    & * {
      flex: 1 1 50%;
    }
  }

  &__label {
    top: 14px;

    &._fixed-label {
      display: none;
    }
  }

  &__error {
    display: none;
  }
}

:deep .form-check {
  &__text {
    white-space: unset;
  }
}

:deep .button {
  &:disabled {
    pointer-events: none;
    background-color: $color_dark-40;
    user-select: none;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 639px) {
  .modal-auth {
    width: 100%;
    top: 65px !important;
    // height: calc(100vh - 65px);
    background-color: white;
    backdrop-filter: none;
    border-top: 1px solid $color_dark-70;
    transition: background-color 0.45s 0.25s ease;

    &._secondary {
      background-color: white;
      backdrop-filter: none;
      border-top: 1px solid $color_dark-70;
      transition: background-color 0.45s 0.25s ease;
    }
  }
}
</style>
